$(() => {
  const toggle_dependencies = () => {
    const fade = 0;
    const include_enhanced = $('#include-enhanced-coverage-pricing').val();
    const rent_or_buy = $('#rent-or-buy').val();
    toggle_declare_dependencies();
 
    $('.impact-and').slideUp(fade);
    
    
    if (rent_or_buy === 'Rent') {
      $('.reduce-capital-spend').slideUp();
      $('.eliminate-generator-maintenance').slideUp();
      $('.reduce-rental-spend').slideDown();
    } else {
      $('.reduce-capital-spend').slideDown();
      $('.eliminate-generator-maintenance').slideDown();
      $('.reduce-rental-spend').slideUp();
    }

    if (include_enhanced === 'Yes') {
      $('.reduce-outage-response-time').slideDown();
      $('.reduce-outage-duration-loss').slideDown();
      $('.reduce-outage-duration-spoilage').slideDown();
      $('.reduce-outage-duration-idle').slideDown();
      $('.reduce-rep-dmg').slideDown();
    } else {
      $('.reduce-outage-response-time').slideUp();
      $('.reduce-outage-duration-loss').slideUp();
      $('.reduce-outage-duration-spoilage').slideUp();
      $('.reduce-outage-duration-idle').slideUp();
      $('.reduce-rep-dmg').slideUp();
    }
  };

  const set_impact_variables = () => {
    const flex = $('#product-flex-checkbox').is(':checked');

    if (flex) {
      $('#pct-rdxn-premiums').val(3);
    } else {
      $('#pct-rdxn-premiums').val(2);
    }
  };

  const toggle_declare_dependencies = () => {
    const fade = 0;
    const declares = parseInt($('#declares').val());

    if (declares === 1) {
      $('#second-largest-generator-size-wrapper').slideUp(fade);
      $('#third-largest-generator-size-wrapper').slideUp(fade);
    } else if (declares === 2) {
      $('#second-largest-generator-size-wrapper').slideDown(fade);
      $('#third-largest-generator-size-wrapper').slideUp(fade);
    } else {
      $('#second-largest-generator-size-wrapper').slideDown(fade);
      $('#third-largest-generator-size-wrapper').slideDown(fade);
    }
  };
  
  const toggle_rent_or_buy_dependencies = () => {
    
  };

  $('.product-options').click(() => {
    set_impact_variables();
    toggle_dependencies();
  });

  $('#include-enhanced-coverage-pricing, #rent-or-buy').change(() => {
    toggle_dependencies();
  });

  $('#declares').change(() => {
    toggle_declare_dependencies();
  });

  $('#level-of-redundancy').change(() => {
    const redundancy = $('#level-of-redundancy').val();

    if (redundancy === 'primary') {
      $('#pct-rdxn-rep-dmg-power').val(0.06);
      $('#pct-rdxn-premiums').val(2);
      $('#pct-rdxn-outage-duration-loss-attr').val(100);
      $('#pct-rdxn-outage-duration-spoilage-attr').val(100);
      $('#pct-rdxn-outage-duration-idle-attr').val(100);
    } else {
      $('#pct-rdxn-rep-dmg-power').val(0.02);
      $('#pct-rdxn-premiums').val(1);
      $('#pct-rdxn-outage-duration-loss-attr').val(50);
      $('#pct-rdxn-outage-duration-spoilage-attr').val(50);
      $('#pct-rdxn-outage-duration-idle-attr').val(50);
    }
  });

  toggle_dependencies();
  toggle_declare_dependencies();
});
